export default {
  default: '値が不正です',
  required: '必須入力項目です。',
  enum: '選択値が不正です',
  whitespace: '空白は許可されていません',
  date: {
    format: '日付書式が不正です',
    parse: '日付として解析できません',
    invalid: '日付として不正です'
  },
  types: {
    string: '文字列として正しくありません',
    method: '関数として正しくありません',
    array: '配列として正しくありません',
    object: 'オブジェクトとして正しくありません',
    number: '数値として正しくありません',
    date: '日付型として正しくありません',
    boolean: '真偽値として正しくありません',
    integer: '整数として正しくありません',
    float: '浮動小数点として正しくありません',
    regexp: '正規表現として正しくありません',
    email: 'メールアドレスとして正しくありません',
    url: 'URLとして正しくありません',
    hex: '16進数として正しくありません'
  },
  string: {
    len: '%s 文字入力してください',
    min: '最低 %s 文字以上入力してください',
    max: '最大 %s 文字以内で入力してください',
    range: '%s 文字以上 %s 文字以内で入力してください'
  },
  number: {
    len: '%s を入力してください',
    min: '最低 %s 以上の数値を入力してください',
    max: '最大 %s 以下の数値を入力してください',
    range: '%s 以上 %s 以下の数値を入力してください'
  },
  array: {
    len: '%s 項目選択してください',
    min: '最低 %s 項目以上選択してください',
    max: '最大 %s 項目以内で選択してください',
    range: '%s 項目以上 %s 項目以内で選択してください'
  },
  pattern: {
    mismatch: '書式が不正です'
  }
}



// WEBPACK FOOTER //
// ./src/lang/locales/ja/validator.js